<template>
  <div>
    <div class="dataTime">
      <span class="demonstration">{{$t('common.date')}} </span>
      <el-date-picker
        v-model="changeValue"
        value-format="yyyy-MM-dd"
        type="daterange"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="dataPage">
      <div class="pageRank">
        <el-card class="half">
          <div class="halfTitle">{{$t('DriverAnalysis.swipesRank')}} </div>
          <div v-if="isValue" v-loading="StartStopOptionLoading">
            <linegraph
              :id="'bargraph1'"
              :data="StartStopOption"
              style="height: 300px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}} </div>
        </el-card>
      </div>
      <div class="pageRank" style="margin: 0 10px">
        <el-card class="half">
          <div class="halfTitle">{{$t('DriverAnalysis.workTimeH')}} </div>
          <div v-if="isShow" v-loading="workOptionLoading">
            <linegraph
              :id="'bargraph2'"
              :data="workOption"
              style="height: 300px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}} </div>
        </el-card>
      </div>
      <div class="pageRank">
        <el-card class="half">
          <div class="halfTitle">{{$t('DriverAnalysis.violationRank')}} </div>
          <div v-if="isDisplay" v-loading="faultOptionLoading">
            <linegraph
              :id="'bargraph3'"
              :data="faultOption"
              style="height: 300px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}} </div>
        </el-card>
      </div>
    </div>
    <div class="dataTable">
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('common.driverNum')">
            <el-input
              size="mini"
              v-model="formInline.driverNum"
              :placeholder="$t('DriverAnalysis.form.driverNum')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.driverName')">
            <el-input
              size="mini"
              v-model="formInline.name"
              :placeholder="$t('DriverAnalysis.form.name')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}} </el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('DRIVERANALYSIS_DRIVERCOMPREHENSIVE_CHANGE_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}} </el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import DriverChangeTime from "./DriverChangeTime";
export default DriverChangeTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>